export default __webpack_public_path__ + "static/media/birrieria-soup.f99f4496.jpeg";